<template>
  <b-modal :title="modalTitle"
           ref="userProfileModal"
           id="userProfileModal"
           size="lg"
           title-tag="h5"
           header-bg-variant="secondary"
           header-class="default-color"
           body-bg-variant="dark"
           body-class="default-color"
           ok-variant="outline-danger"
           cancel-variant="outline-danger"
           footer-bg-variant="dark"
           ok-title="Save Changes"
           ok-disabled>
    <div id="modalBody">
      <b-row cols="6">
        <b-col xs cols="4">Full Name:</b-col>
        <b-col md>{{ user.attributes.given_name }} {{ user.attributes.family_name }}</b-col>
      </b-row>
      <b-row class="mt-3">
        <b-col xs cols="4">Email Address:</b-col>
        <b-col md>{{ user.attributes.email }}</b-col>
        <b-col v-if="!this.user.attributes.email_verified">
          <b-button id="verifyEmail" @click="doEmailValidation" variant="outline-danger">Verify Email</b-button>
        </b-col>
      </b-row>

      <b-row class="mt-3 pb-2 border-bottom">
        <b-col xs cols="4">Phone Number:</b-col>
        <b-col>{{ user.attributes.phone_number | displayPhoneNumber }}</b-col>
        <b-col v-if="!this.user.attributes.phone_number_verified">
          <b-button id="verifyPhone" @click="doPhoneValidation" variant="outline-danger" v-bind:disabled="true">Verify
            Phone Number
          </b-button>
        </b-col>
      </b-row>
      <b-row class="mt-3 mb-3">
        <b-col style="text-align: center"><h5>Notification Preferences</h5></b-col>
      </b-row>
      <b-row>
        <b-col style="text-align: center">coming soon</b-col>
      </b-row>
    </div>
  </b-modal>
</template>

<script>
  import { Auth } from 'aws-amplify'

  export default {
    name: 'UserProfile',
    data () {
      return {
        modalTitle: 'title',
        //build a shell of the user object to prevent race-condition errors in the console
        user: {
          username: '',
          attributes: {
            given_name: '',
            family_name: '',
            email: '',
            email_verified: '',
            phone_number: '',
            phone_number_verified: ''
          }
        }
      }
    },
    methods: {
      showModal () {
        var modal = this.$refs['userProfileModal']
        this.modalTitle = this.user.username + ' Profile'
        modal.show()
      },
      async getUserInfo () {
        if (this.$store.state.apopUser) {
          this.user = await Auth.currentAuthenticatedUser()
          console.log('loaded user')
        }
      },
      doEmailValidation () {
        Auth.verifyCurrentUserAttribute('email').then(() => {
          console.log('requesting email verification code')
          this.$router.push({ name: 'confirmation', params: { confirmType: 'email' } })
        })
      },
      async doPhoneValidation () {
        //Auth.verifyCurrentUserAttribute('phone_number').then(() => {
          console.log('requesting SMS verification code')
        this.$router.push({ name: 'confirmation', params: { confirmType: 'phone_number' } })

        //})
      }
    },
    mounted () {
      this.getUserInfo()
    }
  }
</script>

<style>

</style>
